import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/helpers";
import { ReactNode, useState } from "react";
type TooltipPosition = "left" | "right" | "top" | "bottom";
interface TooltipProps {
  children: ReactNode;
  content: string;
  position?: TooltipPosition;
}
const tooltipContent = {
  positionClasses: {
    left: "right-full mr-2 top-1/2 -translate-y-1/2",
    right: "left-full ml-2 top-1/2 -translate-y-1/2",
    top: "bottom-full mb-2 left-1/2 -translate-x-1/2",
    bottom: "top-full mt-2 left-1/2 -translate-x-1/2"
  }
};
export const Tooltip = t0 => {
  const $ = _c(9);
  const {
    children,
    content,
    position: t1
  } = t0;
  const position = t1 === undefined ? "right" : t1;
  const [isVisible, setIsVisible] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsVisible(true);
    t3 = () => setIsVisible(false);
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== content || $[3] !== isVisible || $[4] !== position) {
    t4 = isVisible && <div className={cn("absolute z-200 px-3 py-1.5 rounded-lg", "backdrop-blur-lg border border-white/25", "bg-linear-to-tr from-black/35 to-black/15", "shadow-lg text-white text-sm whitespace-nowrap", "pointer-events-none", "hidden md:block", tooltipContent.positionClasses[position])}>{content}</div>;
    $[2] = content;
    $[3] = isVisible;
    $[4] = position;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== t4) {
    t5 = <div className="relative inline-block" onMouseEnter={t2} onMouseLeave={t3}>{children}{t4}</div>;
    $[6] = children;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};